import React, { Component } from 'react'
import { connect } from 'react-redux'
import { client } from '../actions'
import { authHeader } from '../helpers/auth-header'
import actions from '../actions/add-orgs.actions'
import { actions as contractorActions } from '../actions/contractor.actions'
import { DatePicker, Col, Row, Form, Modal, Select, Input, Upload, Icon, Radio, Button } from 'antd'
import { dspxGetDocTypesChildrens, dspxGetChildrens, dspxGetChildrensDocumentContractor } from '../helpers/dspx-utils'
import PhoneNumberInput from '../components/phone-input';
import IconCheckBox from '../components/icon-checkbox';
import { EditDocumentIcon, AddRequestIcon, RubleIcon, PossWarrantyIcon, UrgentIcon, DocInIcon, DocOutIcon, DocORDIcon, DocAgreementIcon } from '../resource/icons';
import moment from 'moment'
import ContractorRef from '../components/contractor-ref';
import { documentsConstants } from './Documents/constants/documents.constants';

const { TextArea } = Input;

let id = 1
let addonId = 0

const AddOrgsForm = Form.create()(
	class extends React.Component {
		constructor(props) {
			super(props)

			this.state = {
			}
		}

		add = () => {
			const { form } = this.props;
			const keys = form.getFieldValue('keys');
			const nextKeys = keys.concat(id++);
			form.setFieldsValue({
				keys: nextKeys,
			});
		};

		remove = k => {
			const { form } = this.props;
			const keys = form.getFieldValue('keys');
			if (keys.length === 1) {
				return;
			}	
			form.setFieldsValue({
				keys: keys.filter(key => key !== k),
			});
		};

		render() {
			const { visible, onCancel, onCreate, form, fprops } = this.props;
			const { getFieldDecorator, getFieldValue } = form;	

			const docType = 1

			getFieldDecorator('keys', { initialValue: [0] });
			const keys = getFieldValue('keys');
			const orgsItems = keys.map((k, index) => (
				(docType == 1 || index === 0) && <Row gutter={0} key={k}>
				<Form.Item
					//{...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
					label={index === 0 ? 
						( docType == 1 
							? <div className="ant-form-item-required">Получатели</div> 
							: <div className="ant-form-item-required">Отправитель</div> ) 
						: ''}
					required={false}
					key={k}>
					<Col span={23}>
						<Input.Group compact>
									{getFieldDecorator(`orgId[${k}]`, 
											{ rules: [ { required: docType < 3, message: 'Пожалуйста, укажите организацию отправителя/получателя документа' }]} 
									)(
										<Select
										  style={{ width: docType == 1 ? 350 : 350 }}
											showSearch
											placeholder="организация"
											notFoundContent='нет данных'
											optionFilterProp="searchtext" >
											{dspxGetChildrensDocumentContractor(fprops.documentContractors)}
										</Select>)}
										{docType == 1 && getFieldDecorator(`InNumber[${k}]`, {
										rules: [{ required: false, message: 'Пожалуйста, укажите номер документа' }]
									})(
										<Input placeholder="вх.номер" style={{ width: 110 }} />)}
									{docType == 1 && getFieldDecorator(`InMoment[${k}]`, {
										//initialValue: moment(),
										rules: [{ required: false, message: 'Пожалуйста, укажите дату документа' }]
									})(
										<DatePicker placeholder="вх.дата" style={{width:117}} allowClear={false} format='DD.MM.YYYY' />)}
								</Input.Group>
								</Col>
								<Col span={1} style={{textAlign: 'right'}}>
								{keys.length > 1 && docType == 1 ? (
								<Icon  
									style={{fontSize: 20, color: "#ffb6b6", marginTop: 5}} 
									type="minus-circle"
									onClick={() => this.remove(k)} />
					) : null}
								</Col>
				</Form.Item>
				</Row>
			));

			return (
				<Modal
					style={{minWidth:650}}
					width={650}
					visible={visible}
					title={<span><EditDocumentIcon style={{ height: 40 }}/> Получатели</span>}
					okText="Добавить"
					onCancel={onCancel}
					onOk={onCreate} >
					<Form layout="vertical">
						{getFieldDecorator('docId', { initialValue: fprops.docId })(<Input type='hidden' />)}

						{docType < 3 && orgsItems}
						{docType < 3 && <Row gutter={0} align='middle'>
						<Col span={5} align={'right'}>
							</Col>
						<Col span={9} align={'right'}>
							<Form.Item>
									<ContractorRef reftype='document' addCreatedOrg={(createdOrgId) => {
										const keys = form.getFieldValue("keys");
										for (const key of keys) {
											if (!form.getFieldValue(`orgId[${key}]`)) {
												form.setFieldsValue({ [`orgId[${key}]`]: `${createdOrgId}` });
												break;
											}
										}
								}} />
        			</Form.Item>
							</Col>
							<Col span={9} align={'right'}>
							{ docType == 1 && <Form.Item>
          			<Button type="dashed" onClick={this.add} >
            			<Icon type="plus" />Добавить получателя</Button>
        			</Form.Item>}
							</Col>
							<Col span={1} align={'right'}>
							</Col>
						</Row>}

						{ (docType == 2 || docType == 3) && <Row gutter={8}>
						<Col span={12}>
								<Form.Item label="Исполнитель">
									{getFieldDecorator('executerId', {																					
										rules: [{ required: false, message: 'Пожалуйста, укажите исполнителя' }]
									})(
										<Select
											showSearch
											placeholder="исполнитель"
											notFoundContent='нет данных'
											optionFilterProp="searchtext" >
											{dspxGetChildrens(fprops.listExecuter)}
										</Select>)}
								</Form.Item>
							</Col>
							</Row>}
					</Form>
				</Modal>
			);
		}
	});

class AddOrgsContainer extends Component {

	componentDidMount() {		
		this.props.dispatch(contractorActions.fetchDocumentContractorList());
	}

	handleCancel = () => {
		const form = this.formRef.props.form;
		form.resetFields();
		this.props.dispatch(actions.closeModal());
	}

	handleCreate = () => {
		const form = this.formRef.props.form;

		form.validateFields((err, values) => {

			if (err) return;

			const v = { ...values, 				
				
			}

			console.log(v)

			form.resetFields();
			this.props.dispatch(actions.addDocumentOrgs(v))
			this.props.dispatch(actions.closeModal())
		});
	}

	saveFormRef = (formRef) => {
		this.formRef = formRef;
	}

	render() {
		return (
			<AddOrgsForm
				wrappedComponentRef={this.saveFormRef}
				visible={this.props.modalVisible}
				dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
//				onAddNewContractor={this.handleAddNewContractor}
				fprops={this.props}
			/>
		)
	}
}

function mapStateToProps(state) {
	const { addOrgsStore } = state;
	const { documentContractors } = state.contractorStore;
	return {...addOrgsStore, documentContractors };
}

export default connect(mapStateToProps)(AddOrgsContainer);